// extracted by mini-css-extract-plugin
export default {"OutterDIV":"InitialAbout_OutterDIV__e01ke","TextDIV":"InitialAbout_TextDIV__FImCM"};